import React from 'react';
import { getLocale } from '../../contexts/LanguageContext';
import { classLabel } from '../../config/dofusClasses';

export const fmtDate = (d) => (d ? new Date(d).toLocaleDateString(getLocale(), { day: '2-digit', month: 'short', year: 'numeric' }) : '—');
export const errorOf = (err, fallback) => err?.response?.data?.error || fallback;

export const typeLabel = (t, type) => ({
    add: t('personnages.typeAdd', 'Ajout'),
    edit: t('personnages.typeEdit', 'Modification'),
    remove: t('personnages.typeRemove', 'Retrait'),
    migrate: t('personnages.typeMigrate', 'Migration')
}[type] || type);

export const StatusChip = ({ t, status }) => {
    if (status === 'approved') return <span className="c2-chip c2-chip--green">{t('personnages.statusApproved', 'Validée')}</span>;
    if (status === 'rejected') return <span className="c2-chip perso-chip--danger">{t('personnages.statusRejected', 'Refusée')}</span>;
    return <span className="c2-chip c2-chip--purple">{t('personnages.statusPending', 'En attente')}</span>;
};

/** Contenu d'une demande en une ligne : « Boule-Droite · Iop », « Ancien → Nouveau », « Mikhal → Kourial »... */
export const RequestDetails = ({ t, request }) => {
    const info = classLabel(t, request.classe);
    if (request.type === 'edit') {
        const before = request.previous || {};
        const beforeInfo = classLabel(t, before.classe);
        // Nom inchangé : seule la classe est barrée
        if (before.name === request.name) {
            return (
                <span className="perso-change">
                    <strong>{request.name}</strong>
                    <span className="perso-change__old">{beforeInfo || '—'}</span>
                    <span aria-hidden="true">→</span>
                    <span>{info || '—'}</span>
                </span>
            );
        }
        return (
            <span className="perso-change">
                <span className="perso-change__old">{before.name}{beforeInfo && ` · ${beforeInfo}`}</span>
                <span aria-hidden="true">→</span>
                <strong>{request.name}</strong>{info && <span className="c2-muted"> · {info}</span>}
            </span>
        );
    }
    return (
        <span>
            <strong>{request.name}</strong>
            {info && <span className="c2-muted"> · {info}</span>}
            {request.type === 'migrate' && (
                <span className="c2-muted"> · {t('personnages.migrationRoute', '{from} → {to}', { from: request.fromServerName || '?', to: request.serverName || '?' })}</span>
            )}
        </span>
    );
};
